<div class="po-wrapper">
  <div *ngIf="isLoading" class="sample-container">
    <po-loading-overlay [p-text]="text" [p-size]="size">
    </po-loading-overlay>
  </div>
  <po-page-default class="po-font-title">
    <p>Olá,</p>
    <p>Bem-vindo ao Moda Coletor!</p>

    <div class="po-row po-mt-2" *ngIf="mostAccessedPages.length > 0">
      <h2 class="po-font-subtitle po-font-text-bold">Mais acessados</h2>
    </div>

    <div class="po-row" *ngIf="mostAccessedPages.length > 0">
      <div class="po-lg-2 po-md-2 po-sm-6 po-mb-2" *ngFor="let page of mostAccessedPages">
        <po-widget
          (p-click)="navigateToPage(page.route)"
          [p-no-shadow]="true">
          <div class="widget-content">
            <div class="icon-container">
              <i [class]="page.icon"></i>
            </div>
          </div>
          <div class="widget-title">{{ page.title }}</div>
        </po-widget>
      </div>
    </div>

    <div class="po-row po-mt-2">
      <h2 class="po-font-subtitle po-font-text-bold">Documentação</h2>
    </div>

    <div class="po-row po-font-text">
      <p class="po-mb-1">
        Acesse a nossa documentação para obter informações de liberação de componentes, configurações, manuais de uso e muito mais.
      </p>
      <br>
      <po-button
        p-label="Acessar documentação"
        p-icon="po-icon po-icon-info"
        (p-click)="openDocumentation()">
      </po-button>
    </div>
  </po-page-default>  
</div>